import { registerPlugin } from "@capacitor/core";

const EpsonPrinter = registerPlugin("EpsonPrinter");

export default EpsonPrinter;
